const getCopy = <T>(val: any) => {
  return JSON.parse(JSON.stringify(val)) as T;
};

export { getCopy };
